import { Component, OnInit } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { Profile } from 'src/app/core/entities/profile.entity';
import { ProfileService } from 'src/app/core/services/profile.service';

@Component({
  selector: 'app-settings-modal',
  templateUrl: './settings-modal.component.html',
  styleUrls: ['./settings-modal.component.css'],
})
export class SettingsModalComponent implements OnInit {
  public profile: Profile;
  public active = 'profile';
  public anime: any;

  options: AnimationOptions = {
    path: 'assets/animations/dashboard-return.json',
    loop: false,
    autoplay: false,
  };

  constructor(
    public activeModal: NgbActiveModal,
    private profileService: ProfileService
  ) {}

  ngOnInit(): void {
    this.profile = this.profileService.me;
  }

  /**
   * Lotty Animation created
   * @param animationItem
   */
  animationCreated(animationItem: AnimationItem): void {
    this.anime = animationItem;
  }

  /**
   * Closes modal
   */
  close(): void {
    this.anime.goToAndPlay();
    setTimeout(() => {
      this.activeModal.close();
    }, 1000);
  }
}
